import { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { getRegisterCode, getRegisterType } from '../utils/meterRegister';

import { Fragment } from 'react/jsx-runtime';
import IndexInput from './IndexInput';
import { RegisterType } from '../enums/registerType';
import { useTranslation } from 'react-i18next';

interface StepEncodeIndexItemProps {
	type: string;
	field: ControllerRenderProps<FieldValues, any>;
	previousIndex: number;
	footer?: JSX.Element;
}
function EncodeIndexItem({
	type,
	field,
	previousIndex,
	footer,
}: StepEncodeIndexItemProps) {
	const { t } = useTranslation();

	const getItemType = (type: string) => {
		const registerType = getRegisterType(type);

		switch (registerType) {
			case RegisterType.ELECTRICITY_DAY:
				return (
					<div className='encode-index__item__type'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							strokeWidth='1.5'
							stroke='currentColor'
							className='icon'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								d='M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z'
							/>
						</svg>
						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-day')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY_NIGHT:
				return (
					<div className='encode-index__item__type'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							strokeWidth='1.5'
							stroke='currentColor'
							className='icon'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								d='M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z'
							/>
						</svg>

						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-night')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY:
				return (
					<div className='encode-index__item__type'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							strokeWidth='1.5'
							stroke='currentColor'
							className='icon'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								d='M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z'
							/>
						</svg>

						<span className='encode-index__item__type__text'>
							{t('register.type.electricity')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY_NOT_USED:
				return (
					<div className='encode-index__item__type'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							strokeWidth='1.5'
							stroke='currentColor'
							className='icon'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								d='M12 3v2.25m6.364.386-1.591 1.591M21 12h-2.25m-.386 6.364-1.591-1.591M12 18.75V21m-4.773-4.227-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z'
							/>
						</svg>

						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-not-used')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY_EX_NIGHT:
				return (
					<div className='encode-index__item__type'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							strokeWidth='1.5'
							stroke='currentColor'
							className='icon'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								d='M21.752 15.002A9.72 9.72 0 0 1 18 15.75c-5.385 0-9.75-4.365-9.75-9.75 0-1.33.266-2.597.748-3.752A9.753 9.753 0 0 0 3 11.25C3 16.635 7.365 21 12.75 21a9.753 9.753 0 0 0 9.002-5.998Z'
							/>
						</svg>

						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-ex-night')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY_DAY_PLUS:
				return (
					<div className='encode-index__item__type'>
						<span className='encode-index__item__type__code badge'>
							{getRegisterCode(type)}
						</span>
						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-day-plus')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY_DAY_MIN:
				return (
					<div className='encode-index__item__type'>
						<span className='encode-index__item__type__code badge'>
							{getRegisterCode(type)}
						</span>
						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-day-min')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY_INJECTION_DAY:
				return (
					<div className='encode-index__item__type'>
						<span className='encode-index__item__type__code badge'>
							{getRegisterCode(type)}
						</span>
						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-injection-day')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY_INJECTION_NIGHT:
				return (
					<div className='encode-index__item__type'>
						<span className='encode-index__item__type__code badge'>
							{getRegisterCode(type)}
						</span>
						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-injection-night')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY_NIGHT_PLUS:
				return (
					<div className='encode-index__item__type'>
						<span className='encode-index__item__type__code badge'>
							{getRegisterCode(type)}
						</span>
						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-night-plus')}
						</span>
					</div>
				);
			case RegisterType.ELECTRICITY_NIGHT_MIN:
				return (
					<div className='encode-index__item__type'>
						<span className='encode-index__item__type__code badge'>
							{getRegisterCode(type)}
						</span>
						<span className='encode-index__item__type__text'>
							{t('register.type.electricity-night-min')}
						</span>
					</div>
				);
			case RegisterType.GAS:
				return (
					<div className='encode-index__item__type'>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							fill='none'
							viewBox='0 0 24 24'
							strokeWidth='1.5'
							stroke='currentColor'
							className='icon'
						>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								d='M15.362 5.214A8.252 8.252 0 0 1 12 21 8.25 8.25 0 0 1 6.038 7.047 8.287 8.287 0 0 0 9 9.601a8.983 8.983 0 0 1 3.361-6.867 8.21 8.21 0 0 0 3 2.48Z'
							/>
							<path
								strokeLinecap='round'
								strokeLinejoin='round'
								d='M12 18a3.75 3.75 0 0 0 .495-7.468 5.99 5.99 0 0 0-1.925 3.547 5.975 5.975 0 0 1-2.133-1.001A3.75 3.75 0 0 0 12 18Z'
							/>
						</svg>

						<span className='encode-index__item__type__text'>
							{t('register.type.gas')}
						</span>
					</div>
				);
			default:
				<div className='encode-index__item__type'>no type</div>;
		}
	};

	return (
		<Fragment>
			<fieldset className='encode-index__item'>
				<div className='encode-index__item__header'>{getItemType(type)}</div>

				<div className='encode-index__item__input'>
					<div className='row align-items-md-end'>
						<div className='col-md-6 encode-index__item__input__item'>
							<IndexInput
								field={field}
								value={previousIndex}
								label={t('encode-index.previous')}
							/>
						</div>
						<div className='col-md-6 encode-index__item__input__item'>
							<IndexInput field={field} label={t('encode-index.current')} />
						</div>
					</div>
				</div>
				{footer && (
					<div className='encode-index__error__container ps-4 pe-4 w-100'>
						<p className='arrow-container mb-4'>
							<span className='up-arrow'></span>
						</p>
						{footer}
					</div>
				)}
			</fieldset>
		</Fragment>
	);
}

export default EncodeIndexItem;
